const style = {
    control: {
        backgroundColor: '#fff',
        border:"none",
    },
    '&multiLine': {
        control: {
            fontFamily: 'Nunito Sans',
            minHeight: "30px",
            maxHeight: "30px",
            borderRadius: "10px",
        },
        highlighter: {
            padding: "7px 0px 7px 0px",
            overflow: "hidden",
        },
        input: {
            padding: "7px 0px 7px 0px",
            borderRadius: "10px",
            border: "none",
            outline:"none"
        },
    },
    '&singleLine': {
        display: 'inline-block',
        width: 180,
        highlighter: {
            padding: 1,
            border: 'none',
        },
        input: {
            padding: 1,
            border: 'none',
        },
    },
    suggestions: {
        list: {
            backgroundColor: 'white',
            border: '1px solid rgba(0,0,0,0.15)',
            fontSize: 16,
            borderRadius: "10px",
            maxHeight: '200px',
            overflowY: 'auto', 
        },
        item: {
            padding: '5px 15px',
            borderBottom: '1px solid rgba(0,0,0,0.15)',
            '&focused': {
                backgroundColor: '#fecb03',
            },
        },
    },
}
 export default style;